import window from 'window';

export const cookieConsent = () => {

    const init = () => {
        const cookieControl = window["CookieControl"];
        const config = window["cookieControlConfig"];

        const cookieControlPrefs = document.querySelector(".cookie-control");

        // Used to open the Cookie tool from accounts/Cookie Policy page
        if (cookieControlPrefs) {
            cookieControlPrefs.onclick = () => {
                cookieControl.open();
                return;
            };
        }

        if (config) {
            cookieControl.load(config);
        }
    };

    return {
        init: init
    };
}